import { api } from "@/lib/api";
import { toast } from "sonner";

const loadRazorpay = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

/**
 * Launches Razorpay checkout for a purpose and resolves after server verification.
 * purpose: 'listing_fee' | 'premium_badge'
 * user: { name, email, phone }
 * returns Promise<{ok: true, purpose, mock?: bool} | {ok: false, error}>
 */
export async function payWithRazorpay(purpose, user) {
  try {
    const { data: order } = await api.post("/payments/create-order", { purpose });
    if (order.mock) {
      // Mock mode — simulate server-side verification without opening Razorpay
      try {
        await api.post("/payments/verify", {
          purpose,
          razorpay_order_id: order.order_id,
          razorpay_payment_id: `pay_mock_${Date.now()}`,
          razorpay_signature: "mock_sig",
        });
        toast.success(`Mock payment ✔ (Razorpay keys not configured yet — ₹${order.amount / 100} skipped)`);
        return { ok: true, purpose, mock: true };
      } catch (e) {
        return { ok: false, error: "mock verify failed" };
      }
    }
    const loaded = await loadRazorpay();
    if (!loaded) return { ok: false, error: "Razorpay failed to load" };
    return await new Promise((resolve) => {
      const rzp = new window.Razorpay({
        key: order.key_id,
        amount: order.amount,
        currency: order.currency,
        order_id: order.order_id,
        name: "NimmaSwathu",
        description: purpose === "listing_fee" ? "Listing verification fee" : "Premium Verified badge (30 days)",
        prefill: {
          name: user?.name,
          email: user?.email,
          contact: user?.phone,
        },
        theme: { color: "#C85A32" },
        handler: async (resp) => {
          try {
            await api.post("/payments/verify", {
              purpose,
              razorpay_order_id: resp.razorpay_order_id,
              razorpay_payment_id: resp.razorpay_payment_id,
              razorpay_signature: resp.razorpay_signature,
            });
            resolve({ ok: true, purpose });
          } catch (e) {
            resolve({ ok: false, error: "verification failed" });
          }
        },
        modal: {
          ondismiss: () => resolve({ ok: false, error: "cancelled" }),
        },
      });
      rzp.open();
    });
  } catch (e) {
    return { ok: false, error: e.response?.data?.detail || "Payment init failed" };
  }
}
